/* tslint:disable */
/* eslint-disable */
/**
 * Document Simulation API
 * API for managing document simulations and contractualization strategies
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DocumentMinimalDto
 */
export interface DocumentMinimalDto {
    /**
     * 
     * @type {string}
     * @memberof DocumentMinimalDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentMinimalDto
     */
    label: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentMinimalDto
     */
    storedFileId: string;
}

/**
 * Check if a given object implements the DocumentMinimalDto interface.
 */
export function instanceOfDocumentMinimalDto(value: object): value is DocumentMinimalDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('storedFileId' in value) || value['storedFileId'] === undefined) return false;
    return true;
}

export function DocumentMinimalDtoFromJSON(json: any): DocumentMinimalDto {
    return DocumentMinimalDtoFromJSONTyped(json, false);
}

export function DocumentMinimalDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DocumentMinimalDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'label': json['label'],
        'storedFileId': json['storedFileId'],
    };
}

export function DocumentMinimalDtoToJSON(json: any): DocumentMinimalDto {
    return DocumentMinimalDtoToJSONTyped(json, false);
}

export function DocumentMinimalDtoToJSONTyped(value?: DocumentMinimalDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'label': value['label'],
        'storedFileId': value['storedFileId'],
    };
}

